import { Entity } from '@toggle/toggle';
import React from 'react';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { ErrorMessageWrapper } from '~/components/error-message-wrapper/ErrorMessageWrapper';
import { BrandAndProductDrawer } from '~/modules/brand-and-product-drawer/BrandAndProductDrawer';

import { BrandsAndProductsTable } from './brands-and-products-table/BrandsAndProductsTable';
import styles from './BrandsAndProductsTab.module.scss';

export interface BrandsAndProductsTabProps {
  entity: Entity;
}

export const BrandsAndProductsTab = ({ entity }: BrandsAndProductsTabProps) => {
  return (
    <div className={styles.root} data-testid="brands-and-products-tab">
      <ErrorBoundaryWrapper
        fallback={
          <ErrorMessageWrapper
            className={styles.styledErrorMessageWrapper}
            displayIcon
          />
        }
      >
        <BrandsAndProductsTable entity={entity} />
      </ErrorBoundaryWrapper>
      <BrandAndProductDrawer entity={entity} />
    </div>
  );
};
